<template>
  <div class="outer">

    <div class="item-list">

      <div class="content">
        <div class="title_div" v-if="info.background">
<!--          <img src="../../assets/img/group_coupon/bg_title.png" alt>-->
          <img :src="imgDomain+info.background" alt>
        </div>

        <div class="coupon-list" v-if="coupon_list.length > 0">
          <div class="item height"
               v-for="(item, index) in coupon_list" :class='{red: item.discount_condition.user_limit == 3}'
               v-if="item.discount_condition.discount_value"
          >
            <div class="up">
              <div class="left">
                <div class="discount"><span>{{item.discount_condition.discount_name}}</span><span>折</span></div>
                <div class="limit">{{+item.amount_limit === 0 ? '无门槛券' : ('满'+ (+item.amount_limit) + '元可用')}}</div>
              </div>
              <div class="line"></div>
              <div class="right" :class="{oneLineTxt: item.discount_type!=0}">
                <div class="num" v-if="item.discount_type==0">{{item.discount_condition.user_limit}}人拼团</div>
                <div class="name">{{item.name}}</div>
              </div>
            </div>
            <div class="low">
              <div class="txt">
                <div class="time">使用期限：{{timeStampToDate(item.use_start_time)}} 至 {{timeStampToDate(item.use_end_time)}}</div>
                <div class="declare">使用说明：{{item.instructions}}</div>
              </div>
              <div class="price" v-if="+item.price !== 0">
                <span>仅需</span> <span>¥</span> <span>{{splitDec(item.price).integer}}</span><span>{{splitDec(item.price).decimal}}</span>
              </div>
              <div class="btn"
                   :class='{red: item.discount_condition.user_limit == 3, gray: !checkCouponStatus(item).able}'
                   @click='openApp() || startGroup(item)'
              >
                {{checkCouponStatus(item).btnTxt}} <!-- 开团领券 -->
              </div>
            </div>
          </div>
        </div>

        <div class="item group-list my-group"  v-if="my_group.length > 0">
          <div class="til">
            <img src="./../../assets/img/group_coupon/my_group.png" alt>
          </div>
          <div class="group" v-for="(item, index) in my_group" :class='{red: item.limit_user === 3}'>
            <div class="group-info">
              <div class="group-name">【{{item.name}}】 <!--{{item.user_name}}--></div>
              <div class="info">还差<span>{{item.limit_user-item.exist_user}}</span>人成团，剩余时间
                <span>{{secToTime(item.rest_time, 'my_group', index).d}}</span>天
                <span>{{secToTime(item.rest_time, 'my_group', index).time}}</span>
              </div>
            </div>
            <div class="txt-btn"
                 @click="openApp(true, 'shareToFriends') || shareGroup(item)" v-if="!inWechat">分享
            </div>
            <div class="txt-btn" :class="{leftMore: inWechat}" @click="openApp() || (()=>{selected.discount_type=item.discount_type; jumpToDetail(item.id);})()">详情</div>
          </div>
        </div>

        <div class="item group-list other-group"  v-if="other_group.length > 0">
          <div class="til"><img class="height" src="./../../assets/img/group_coupon/others_group.png" alt></div>
          <div class="group" v-for="(item, index) in other_group" :class='{red: item.limit_user === 3}'>
            <div class="group-info">
              <div class="group-name">【{{item.name}}】 {{item.group_user_name}}</div>
              <div class="info">还差<span>{{item.limit_user-item.exist_user}}</span>人成团，剩余时间
                <span>{{secToTime(item.rest_time, "other_group", index).d}}</span>天
                <span>{{secToTime(item.rest_time, "other_group", index).time}}</span>
              </div>
            </div>
            <div class="btn" @click="openApp() || joinGroup(item)">去拼团</div>
          </div>
        </div>

        <div class="item inform" v-if="info.content && info.content !== ''">
          <div class="til"><img src="../../assets/img/group_coupon/event_rule.png" alt=""></div>
          <div class="rich-text" v-html="info.content"/>
        </div>
      </div>
    </div>

    <div class="share-event">
      <img @click="openApp(true, 'shareToFriends') || shareEvent()" src="../../assets/img/group_coupon/share-float-btn.png" alt="Share">
    </div>

    <!--<div class="open-browser-cover"
         @click="isShowOpenBrowser=!isShowOpenBrowser"
         v-show="isShowOpenBrowser"
    >
      <img src="./../../assets/img/group_coupon/open_browser.png" alt="打开浏览器操作">
    </div>-->
    <cover ref="hintCover" :show.sync="isShowCoverHint" :type="hintType"></cover>

    <pay
      :price="selected.price.toString()"
      :show.sync="isShowPay"
      @click-btn="goPay"
    ></pay>

    <pop
      :show.sync="isShowPop"
      :title="'领取成功'"
      :cancel-btn="'我知道了'"
      :confirm-btn="'立即使用'"
      :confirm-func="()=>{toMyHome()}"
    ></pop>

  </div>
</template>

<script>
import {
  couponActivityInfo,
  couponJoinGroupCheck,
  couponJoinGroupPay,
  couponPay,
  couponPayCheck,
  getWxJsSdkConfig
} from "../../api/api"
import Pop from "../../component/Pop"
import Pay from "../../component/pay/Pay"
import group_coupon from "../../js/group_coupon/group_coupon"

import utils from "../../jslib/utils"
import pay from "../../js/group_coupon/pay"
import {appDomain, imgDomain} from "../../jslib/env"
import Cover from "../../component/cover/cover"

export default {
  name: "GroupCoupon",
  components: {Cover, Pay, Pop},
  data(){
    return {

      info: {},
      coupon_list: [],
      my_group: [],
      other_group: [],
      activity_id: undefined,

      selected:{
        coupon_id: undefined,
        group_id: undefined,
        price: '0.00',
        isFoundAGroup: true,
        discount_type: undefined    // 0-拼团券 1-普通折扣券
      },

      isShowPay: false,
      isShowPop: false,
      isShowOpenBrowser: false,
      is_not_inside: undefined,

      isShowCoverHint: false,
      hintType: 'openBrowser',

      code: undefined, // 微信支付code
      inWechat: utils.getPlatform().weChat,

      openTime: 0,
      countDown: undefined,

      eventRuleTxt: '1.一个用户一个团只能领取一次\n' +
        '2.用户支付未成功不记录,可再次领取\n' +
        '3.用户成功支付后,在“我的-我的优惠券”生成一张待生效优惠券\n' +
        '4.优惠券使用范围:仅限系统家具类产品',
      eventRuleHtml: '<p><b>活动时间：2020年10月1日——10月31日</b></p><p><b>活动对象：魔方屋app注册用户</b></p><p><b>活动细则：</b></p><p>1.&nbsp;开团者通过魔方屋app拼团页面发送专属开团链接，参团者在收到邀请后，在参团页面完成用户参与。拼团完成指在参团页面中输入手机号并进入团列表中，完成以上操作才视为成功参与本团购活动，否则视为参与不达标。</p><p>2.&nbsp;活动时间内，每个用户最多可获得两张不同券额的团购优惠券，参团者亦如此。</p><p>3.&nbsp;开团和参团仅需支付9.9元，拼团成功即可享受相应折扣优惠。</p><p>4.&nbsp;已成团已支付的团购优惠券实付金额不予退还。</p><p>5.&nbsp;未成团已支付的实付金额将在拼团失效后的24小时内按原路退回，请注意及时查看。</p><p>6.&nbsp;每一次开团之后，成团有效期为开团内72小时，用户需在72小时内完成成团任务，否则团过期无效，需用户重新开团。</p><p>7.&nbsp;团购优惠券支付成功后可在“魔方屋-我的-我的优惠券”列表查看，购买商品时在结算页面选择可用的优惠券即可。</p><p>8.&nbsp;团购优惠券有效期为自领取之日起——2020年11月30日，请及时使用，过期作废。</p><p>9.&nbsp;团购折扣仅限魔方屋家具类产品使用，窗帘、家电、灯具类不享受团购优惠。</p><p>10.&nbsp;本活动解释权归深圳易道魔方系统科技有限公司所有。</p><p>11.&nbsp;本活动与苹果公司无关。</p>'
    }
  },
  created() {
    let {activity_id, coupon_id, pay_fail, is_not_inside} = this.$route.query
    this.activity_id = activity_id
    this.is_not_inside = is_not_inside

    if(pay_fail) this.$uihelper.toast('支付未成功')

    this.setToken()

    this.countTime()

    if(utils.getPlatform().weChat) this.code = pay.getWxCode()

    this.network().getInfo(activity_id, coupon_id)
  },
  methods:{
    shareEvent(){
      let title = '超级划算，魔方屋全屋家具超级折扣等你来领！'
      let desc = ''
      let url = 'groupCoupon?is_not_inside=1&activity_id=' + this.activity_id
      let exist = []

      for(let i in this.coupon_list){
        let coupon = this.coupon_list[i]
        let {user_limit, discount_name} = coupon.discount_condition
        let linkComma = this.coupon_list.length-1 == i ? '!' : (desc === '' ? '' : ',')

        if(coupon.discount_type == 0){
          let exist_str = user_limit+','+discount_name
          if(!exist.includes(exist_str)) desc += user_limit + '人拼团享' + discount_name +'折优惠' + linkComma
          exist.push(exist_str)
        }else{
          let exist_str = discount_name
          if(!exist.includes(exist_str)) desc += discount_name + '折优惠券' + linkComma
          exist.push(exist_str)
        }
      }

      if(this.inWechat){
        this.network().share({title, desc, link: appDomain+url, imgUrl: imgDomain+this.info.image})
        return
      }

      this.shareURL(title, desc, url, this.info.image)

    },
    checkCouponStatus(item){

      // quantity_limit: 是否已达到限领数量: 0-否，1-是,如果达到，显示已领完
      // get_status: 允许领券状态: 0-未开始，1-进行中，2-已经结束
      // discount_type: 折扣类型: 0-拼团折扣，1-普通折扣
      let {quantity_limit, get_status, discount_type} = item

      let btnTxt = new Map([ [0, '开团领券'], [1, '立即领券'] ]).get(+discount_type)

      let status = { btnTxt, able: true }

      let gMap = new Map([[0,'未开始'],[1,btnTxt],[2,'已经结束']])
      let qMap = new Map([[0,btnTxt],[1,'已领完']])

      if( [0,2].includes(get_status) ){
        status = {btnTxt: gMap.get(get_status), able: false}
      }else if(quantity_limit == 1){
        status = {btnTxt: qMap.get(quantity_limit), able: false}
      }

      return status
    },
    jumpToDetail(group_id){
      if(this.inWechat){
        this.navigateTo(this.getDetailUrl(group_id))                       // todo: 处理不是在app内部时的情况
      }else{
        this.navigateToNewAct(this.getDetailUrl(group_id, 1))
      }
    },
    getDetailUrl(group_id, is_inside){

      // 券团完成后跳转至团详情页; 普通券支付完成后 刷新当前页

      let url = this.selected.discount_type == 0 ?
        'groupCouponDetail?is_inside=' + is_inside + '&group_id=' + group_id + '&activity_id=' + this.activity_id :
        (utils.getEnv() === 'web' ? utils.delUrlQS(this.$route.fullPath, 'code') : null)

      return url
    },
    startGroup(item){

      let {id, price, discount_type} = item

      // 检查登录
      if(!this.checkLogin()) return

      this.selected.coupon_id = id
      this.selected.price = price
      this.selected.isFoundAGroup = true
      this.selected.discount_type = discount_type

      // 0元直接领取
      if(+price===0){
        this.network().checkAndClaimDirectly(id, 'coupon')
        return
      }

      this.network().couponPayCheck(id)
    },
    joinGroup(item){

      let {id, price, discount_type} = item

      // 检查登录
      if(!this.checkLogin()) return

      this.selected.group_id = id
      this.selected.price = price
      this.selected.isFoundAGroup = false
      this.selected.discount_type = discount_type

      // 0元直接领取
      if(+price===0){
        this.network().checkAndClaimDirectly(id, 'group')
        return
      }

      this.network().couponJoinGroupCheck(id)

    },
    goPay(payMethod){
      console.log('支付方法', payMethod)

      let {isFoundAGroup, coupon_id, group_id, discount_type} = this.selected

      if(isFoundAGroup){

        // 微信内直接唤起支付
        if(this.inWechat){
          pay.arouseWechatPay(discount_type==0 ? 'couponPay' : 'regularCoupon', coupon_id)
        }else{
          this.network().couponPay(coupon_id, payMethod)
        }

      }else{

        // 微信内直接唤起支付
        if(this.inWechat){
          pay.arouseWechatPay('couponJoinGroupPay', group_id)
        }else{
          this.network().couponJoinGroupPay(group_id, payMethod)
        }

      }
    },
    openApp(wechatToBrowser, HintType){
      let is_inside = +this.is_not_inside === 1 ? 0 : 1

      this.$refs.hintCover.hintType = HintType

      return this.openApp_(is_inside, 'event', wechatToBrowser, HintType)
      // return this.$refs.hintCover.openApp(is_inside, 'event', wechatToBrowser, HintType)
    },
    shareGroup(item){

      let {title, desc, url, image} = this.shareGroup_(Object.assign({activity_id: this.activity_id}, item))

      if(this.inWechat) this.network().share({title, desc, link: appDomain+url, imgUrl: imgDomain+image})

    },

    // --- Common func ---
    splitDec: group_coupon.splitDec,
    shareGroup_: group_coupon.shareGroup,
    openApp_: group_coupon.openApp,
    timeStampToDate: group_coupon.timeStampToDate,
    secToTime_: group_coupon.secToTime,

    // --- Time ---
    countTime(){
      this.countDown = setInterval(()=>{ this.openTime++ }, 1000)
    },
    secToTime(sec, arrName, index){
      sec -= this.openTime
      if(sec < 0) this[arrName].splice(index, 1)

      let {d,h,m,s} = this.secToTime_(sec)

      return {d, time: h + ':' + m + ':' + s}
      // return d + '天' + h + ':' + m + ':' + s
    },

    // --- NetWork ---
    network(){
      return{
        // 当前活动信息
        getInfo: async (activity_id, coupon_id) => {
          // let data = couponActivityInfoData                                      // 测试数据
          let {data} = await couponActivityInfo({activity_id, coupon_id})

          console.log('活动信息', data)

          let {coupon_list, info, my_group, other_group} = data.data

          this.info = info || {}
          this.coupon_list = coupon_list || []
          this.my_group = my_group || []
          this.other_group = other_group || []

          window.document.title = info.title || '拼团礼券优惠活动'
        },

        // 领券前检查
        couponPayCheck: async (coupon_id) => {
          let {data} = await couponPayCheck({coupon_id})
          console.log('检查领取', data)

          let {code, message} = data

          if(code == 200){
            if(this.inWechat){
              this.goPay('wechat')
            }else {
              this.isShowPay = !this.isShowPay
            }
          }else{
            this.$uihelper.toast(message)
          }

        },

        // 支付
        couponPay: async (coupon_id, pay_type) => {

          let {data} = await couponPay({coupon_id, pay_type})
          console.log('支付团券', data)

          let {group_id, order_num} = data.data

          this.handle().arouseAppPay(data, pay_type, this.getDetailUrl(group_id, 1))

        },

        // 直接领取
        checkAndClaimDirectly: async (id, idType)=>{

          let pay_type = 'wechat'                                  // 直接领券默认用”微信支付“
          let trade_type = new Map([
            ['web', 'JSAPI'],
            ['ios', 'APP'],
            ['android', 'APP']
          ]).get(utils.getEnv())

          let payment_author_code = this.code || sessionStorage.wx_code

          if(trade_type === 'JSAPI' && this.inWechat && !payment_author_code){
            this.$uihelper.toast('微信授权失败')
            return
          }

          switch (idType){
            case 'coupon':
              var {data} = await couponPayCheck({coupon_id: id})
              console.log('检查领取', data)

              var {code, message} = data
              if(code == 200){
                let {data} = await couponPay({coupon_id: id, pay_type, trade_type, code: payment_author_code})
                this.handle().popAfterClaim(data)
              }else {
                this.$uihelper.toast(message)
              }
              break;

            case 'group':
              var {data} = await couponJoinGroupCheck({group_id: id})
              console.log('加入团前检查', data)

              var {code, message} = data
              if(code == 200){
                let {data} = await couponJoinGroupPay({group_id: id, pay_type, trade_type, code: payment_author_code})
                this.handle().popAfterClaim(data)
              }else {
                this.$uihelper.toast(message)
              }
              break;
          }
        },

        // 加入团验证
        couponJoinGroupCheck: async (group_id) => {
          let {data} = await couponJoinGroupCheck({group_id})
          console.log('加入团前检查', data)

          let {code, message} = data

          if(code == 200){
            if(this.inWechat){
              this.goPay('wechat')
            }else {
              this.isShowPay = !this.isShowPay
            }
          }else{
            this.$uihelper.toast(message)
          }
        },

        // 加入团并支付
        couponJoinGroupPay: async (group_id, pay_type) => {

          let {data} = await couponJoinGroupPay({group_id, pay_type})
          console.log('加入团并支付', data)

          this.handle().arouseAppPay(data, pay_type, this.getDetailUrl(group_id, 1))

        },

        // 微信分享配置信息
        share: async (shareDesc) => {
          let {data} = await getWxJsSdkConfig()
          console.log('微信分享配置', data)

          let {code, message} = data
          if(code == 200){
            let {config} = data.data
            utils.wxShare(config, shareDesc)
          }else {
            this.$uihelper.toast(message)
          }
        }
      }
    },
    handle(){
      return{
        arouseAppPay: (data, pay_type, nextUrl) => {
          let {code, message} = data

          if(code == 200){
            this.payFromH5(data.data, pay_type, nextUrl)
            this.isShowPay = false
          }else{
            this.$uihelper.toast(message)
          }
        },

        // 直接领券后弹出\跳转
        popAfterClaim: (data)=>{
          let {code, message} = data
          if(code == 200 || code == 201){
            if(this.selected.discount_type==0){

              let toastMsm = this.selected.isFoundAGroup ? '开团成功' : '加入团成功'
              this.$uihelper.toast(toastMsm)

              setTimeout(()=>{
                this.jumpToDetail(data.data.group_id, toastMsm)
              }, 1200)

            }else{
              this.isShowPop = true                 // 弹出确认窗口
            }
          }else{
            this.$uihelper.toast(message)
          }
        },
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import "./groupCoupon";
</style>
